import { Injectable } from "@angular/core";
import {
	DataProtectionConfigService,
	FraudPreventionConfigService,
	GroupIBFraudPreventionService,
} from "@obg/ngx.common";
import { CoreHttpClient, Jurisdiction, ProductType } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { RegistrationConfigService } from "../registration.config";
import { RegistrationResponse } from "../registration.model";
import { RegistrationService } from "../registration.service";

import { DgaRegistrationPayload, DgaRegistrationRequest } from "./dga-registration.model";

@Injectable({
	providedIn: "root",
})
export class DgaRegistrationService {
	constructor(
		private httpClient: CoreHttpClient,
		private registrationConfig: RegistrationConfigService,
		private dataProtectionConfig: DataProtectionConfigService,
		private registrationService: RegistrationService,
		private fraudPreventionConfigService: FraudPreventionConfigService,
		private groupIBFraudPreventionService: GroupIBFraudPreventionService
	) {}

	registerDgaCustomer(
		payload: DgaRegistrationPayload,
		product = ProductType.Common
	): Observable<RegistrationResponse> {
		return this.httpClient.post<RegistrationResponse>({
			url: this.registrationConfig.getRegistrationTokensEndpoint(),
			data: this.buildRegisterRequest(payload, product),
		});
	}

	private buildRegisterRequest(payload: DgaRegistrationPayload, product: ProductType): DgaRegistrationRequest {
		const { additionalDetails, iovationBlackBox, depositLimit, credential } = payload;
		const { street, zipCode, city, phoneNumber, phoneExtension } = additionalDetails;

		let consents = payload.consents;
		let marketingOffers = payload.marketingOffers;

		if (!this.dataProtectionConfig.getMarketingConsentDisabled() && consents) {
			consents = {
				brandMarketing: this.registrationService.getMarketingConsentsOptOutEnabled("DK", Jurisdiction.Dga)
					? !consents.brandMarketing
					: consents.brandMarketing,
			};

			marketingOffers = {
				acceptEmailOffers: consents.brandMarketing,
				acceptSmsOffers: consents.brandMarketing,
				acceptTelesalesOffers: consents.brandMarketing,
			};
		}

		return {
			language: "da",
			timeZone: "utc",
			address: {
				street,
				zipCode,
				city,
				country: "Denmark",
			},
			affiliateMetadata: this.registrationService.getAffiliateMetaData(),
			credential: {
				...credential,
				username: credential.email,
			},
			currency: "DKK",
			depositLimit,
			subscriptions: {
				...marketingOffers,
				email: credential.email,
				phoneExtension: phoneExtension.replace(/(^\+?)/, "+"),
				phoneNumber,
			},
			person: { ...payload.person },
			iovationBlackBox: this.fraudPreventionConfigService.getEnabledInRegistration() ? iovationBlackBox : "",
			fraudToken: this.groupIBFraudPreventionService.getSessionId(),
			legal: {
				termsAndConditions: true,
			},
			consents,
			productMetadata: {
				registeredFromProduct: product,
			},
		};
	}
}
